/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step3_TitleInputs */

const es_cap_step3_title = /** @type {(inputs: Cap_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptas o rechazas`)
};

const gl_cap_step3_title = /** @type {(inputs: Cap_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptas ou rexeitas`)
};

const en_cap_step3_title = /** @type {(inputs: Cap_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept or decline`)
};

/**
* | output |
* | --- |
* | "Accept or decline" |
*
* @param {Cap_Step3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step3_title = /** @type {((inputs?: Cap_Step3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step3_title(inputs)
	if (locale === "en") return en_cap_step3_title(inputs)
	return es_cap_step3_title(inputs)
});